import { handleTextResponse } from '../Helpers/handle-text-response';

export const passwordService = {
    getPassword,
};


function getPassword(id, password) {
    const requestOptions = { method: 'POST', headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    }, body: JSON.stringify({clientId: id, password: password}) };

    return fetch(process.env.REACT_APP_APIURL + 'clients/encryptPassword', requestOptions).then(handleTextResponse);

   
}
